<template>
  <main :class="['legal', $route.params.legal]">
    <article>
      <AppHeadline
        class="legal__title"
        :data="{
          content: legal[$route.params.legal].title,
          type: 2,
        }"
      />
      <section
        v-for="(section, i) in legal[$route.params.legal].sections"
        :key="i"
      >
        <AppHeadline
          class="section__title"
          :data="{
            content: section.title,
            type: 3,
          }"
        />
        <AppParagraph
          :data="{
            content: section.content,
          }"
        />
      </section>
    </article>
    <AppFooter />
  </main>
</template>

<script>
import AppHeadline from '@/components/AppHeadline.vue';
import AppParagraph from '@/components/AppParagraph.vue';
import AppFooter from '@/components/AppFooter.vue';

import legal from '@/assets/data/legal.json';

export default {
  name: 'LegalPrivacy',
  components: {
    AppHeadline,
    AppParagraph,
    AppFooter,
  },
  data() {
    return {
      legal,
    };
  },
};
</script>

<style lang="scss" scoped>
.legal {
  article {
    padding: 120px 20px 60px;
    background-image: linear-gradient(180deg, #9EA0AC 0%, #141B37 100%);

    @include mq(ipadL) {
      padding: 120px 15vw 60px;
    }
  }

  section {
    margin-bottom: 60px;

    .section__title {
      text-align: left;
      margin-bottom: 10px;
    }
  }
}
</style>
